/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsClearingV1SweepParticipantStatsEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_CLEARING_V1_SWEEP_PARTICIPANT_STATS_EVENT_ENTITY_NAME = 'ixc.sweeps.clearing.v1.SweepParticipantStatsEvent';
export const ixcSweepsClearingV1SweepParticipantStatsEventEntity = new schema.Entity<IxcSweepsClearingV1SweepParticipantStatsEvent>(IXC_SWEEPS_CLEARING_V1_SWEEP_PARTICIPANT_STATS_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcSweepsClearingV1SweepParticipantStatsEvent) => `${entity.metadata?.eventId}` });

